import { Root } from 'src/App/Root';
import { getLogger } from 'src/modules/logger';
import { UnhandledErrorPage } from 'src/views/pages/UnhandledErrorPage';

import { AppContent } from './AppContent';

export const App = () => {
  try {
    return (
      <AppContent>
        <Root />
      </AppContent>
    );
  } catch (error) {
    const { logError } = getLogger();
    logError(error, {
      note: 'Error rendering App',
    });

    return (
      <AppContent>
        <UnhandledErrorPage />;
      </AppContent>
    );
  }
};
